// ✅ REEMPLAZAR client/src/components/NavBar/navbar.js
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import "./navbar.css";
import { useNavbar } from "../../context/NavbarContext";
import { useAuth } from "../../context/AuthContext";
import {
  Timeline as ViajesI,
  Troubleshoot as BitacoraI,
  Route as RutasI,
  AddLocation as PuntosI,
  LocalShipping as UnidadesI,
  AirlineSeatReclineNormal as ChoferesI,
  AppRegistration as RegistroI,
  PersonAdd as ClientesI,
  People as UsuariosI,
  Security as RolesI,
  VpnKey as PermisosI,
  Logout as LogoutI,
  AccountCircle as ProfileI,
  ExpandMore as ExpandMoreI,
  ExpandLess as ExpandLessI,
  Description as DocumentI,
  LocalShipping as FlotaIcon,
  LocalOffer as MaterialesI,
  BeachAccess as VacacionesI,
  PersonAdd as PersonAdd,
} from "@mui/icons-material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import BadgeIcon from "@mui/icons-material/Badge"; // o GroupsIcon

import Logo from "../../media/logo.png";
import useColorMode from "../../hooks/useColorMode";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, toggleNavbar } = useNavbar();

  const isActive = (path) => location.pathname === path;
  const isActiveParent = (...paths) =>
    paths.some((p) => location.pathname.startsWith(p));
  const { user, logout, hasPermission } = useAuth();
  const { mode, toggleMode } = useColorMode();

  // ✅ ESTADO PARA SECCIONES EXPANDIBLES
  const [expandedSections, setExpandedSections] = useState({
    admin: false,
    operations: true,
  });

  // ✅ ESTADO PARA MENUS DE MUI (viajes y documentos)
  const [viajesAnchor, setViajesAnchor] = useState(null);
  const [documentosAnchor, setDocumentosAnchor] = useState(null);

  const viajesMenuOpen = Boolean(viajesAnchor);
  const documentosMenuOpen = Boolean(documentosAnchor);

  const [bitacorasAnchor, setBitacorasAnchor] = useState(null);
  const bitacorasMenuOpen = Boolean(bitacorasAnchor);

  const [rutasAnchor, setRutasAnchor] = useState(null);
  const rutasMenuOpen = Boolean(rutasAnchor);

  // ✅ HANDLERS PARA MENUS
  const handleViajesClick = (event) => {
    if (isOpen) {
      // Modo normal: toggle expandedSections
      toggleSection("viajes");
    } else {
      // Modo cerrado: abrir Menu de MUI
      setViajesAnchor(event.currentTarget);
    }
  };
  const handleBitacorasClick = (event) => {
    if (isOpen) {
      toggleSection("bitacoras");
    } else {
      setBitacorasAnchor(event.currentTarget);
    }
  };

  const handleBitacorasClose = () => {
    setBitacorasAnchor(null);
  };

  const handleRutasClick = (event) => {
    if (isOpen) {
      toggleSection("rutas");
    } else {
      setRutasAnchor(event.currentTarget);
    }
  };

  const handleRutasClose = () => {
    setRutasAnchor(null);
  };

  const handleViajesClose = () => {
    setViajesAnchor(null);
  };

  const handleDocumentosClick = (event) => {
    if (isOpen) {
      toggleSection("documentos");
    } else {
      setDocumentosAnchor(event.currentTarget);
    }
  };

  const handleDocumentosClose = () => {
    setDocumentosAnchor(null);
  };

  // ✅ RESETEAR SECCIONES CUANDO SE CIERRA EL NAVBAR
  useEffect(() => {
    if (!isOpen) {
      setExpandedSections({
        admin: false,
        operations: false,
        bitacoras: false,
      });
      // Cerrar menus de MUI si estaban abiertos
      setViajesAnchor(null);
      setDocumentosAnchor(null);
      setRutasAnchor(null);
    } else {
      setExpandedSections((prev) => ({
        ...prev,
        operations: true,
      }));
    }
  }, [isOpen]);

  // ✅ FUNCIÓN PARA TOGGLE DE SECCIONES
  const toggleSection = (section) => {
    if (!isOpen) return;

    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // ✅ FUNCIÓN DE LOGOUT
  const handleLogout = async () => {
    if (window.confirm("¿Estás seguro de que deseas cerrar sesión?")) {
      await logout();
      navigate("/login");
    }
  };

  // ✅ FUNCIÓN PARA NAVEGACIÓN
  const handleNavigation = (path) => {
    navigate(path);
    // Cerrar menus al navegar
    handleViajesClose();
    handleDocumentosClose();
    handleRutasClose();
  };

  return (
    <div className={`navbarDiv ${isOpen ? "open" : "closed"}`}>
      {/* ✅ HEADER CON LOGO */}
      <div className="logoDiv">
        <img src={Logo} alt="Logo" className="logo" />
        {isOpen && <label className="label openLabel">SysGago</label>}
      </div>

      {/* ✅ INFORMACIÓN DEL USUARIO */}
      {isOpen && user && (
        <div className="userInfo">
          <div className="userProfile">
            <ProfileI className="userIcon" />
            <div className="userDetails">
              <span className="userName">{user.nombre}</span>
              <span className="userRole">{user.rol || "Sin rol"}</span>
            </div>
          </div>
        </div>
      )}

      {/* ✅ NAVEGACIÓN PRINCIPAL */}
      <div className="navContent">
        {/* ✅ SECCIÓN OPERACIONAL */}
        <div className="navSection">
          {isOpen && (
            <button
              className="sectionHeader"
              onClick={() => toggleSection("operations")}
            >
              <span>Operaciones</span>
              {expandedSections.operations ? <ExpandLessI /> : <ExpandMoreI />}
            </button>
          )}

          <div
            className={`sectionContent ${
              isOpen
                ? expandedSections.operations
                  ? "visible"
                  : "hidden"
                : "iconsOnly"
            }`}
          >
            {/* Dice "Flota" y no "Dashboard" porque ahora es un mapa de flota:
                dejar la etiqueta vieja sobre otra pantalla sería una etiqueta
                que miente. La RUTA sigue siendo `/dashboard` a propósito —no se
                toca un path que la gente pueda tener guardado—, y el gate sigue
                siendo `viajes.leer`, el mismo que el de la página y el del
                endpoint que la alimenta. */}
            {hasPermission("viajes.leer") && (
              <button
                onClick={() => navigate("/dashboard")}
                className={`navButton${isActive("/dashboard") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <FlotaIcon className="icon" />
                  {isOpen && <label className="label">Flota</label>}
                </div>
              </button>
            )}

            {/* ✅ VIAJES CON MENU DE MUI */}
            {(hasPermission("viajes.leer")) && (
              <div className="submenu">
                <button
                  onClick={handleViajesClick}
                  className={`navButton${isActiveParent("/viajes", "/calendario") ? " active" : ""}`}
                  title={!isOpen ? "Viajes" : ""}
                  style={{ width: "100%", justifyContent: "flex-start" }}
                >
                  <div className="buttonDiv">
                    <ViajesI className="icon" />
                    {isOpen && <label className="label">Viajes</label>}
                    {isOpen &&
                      (expandedSections.viajes ? (
                        <ExpandLessI />
                      ) : (
                        <ExpandMoreI />
                      ))}
                  </div>
                </button>

                {/* Submenú normal cuando está abierto */}
                {isOpen && expandedSections.viajes && (
                  <div className="submenuContent">
                    <button
                      onClick={() => handleNavigation("/viajes")}
                      className={`navButton submenuButton${isActive("/viajes") ? " active" : ""}`}
                    >
                      <span>Tabla</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/calendario")}
                      className={`navButton submenuButton${isActive("/calendario") ? " active" : ""}`}
                    >
                      <span>Calendario Semanal</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/calendario/mensual")}
                      className={`navButton submenuButton${isActive("/calendario/mensual") ? " active" : ""}`}
                    >
                      <span>Calendario Mensual</span>
                    </button>
                  </div>
                )}

                {/* Menu de MUI cuando está cerrado */}
                <Menu
                  anchorEl={viajesAnchor}
                  open={viajesMenuOpen}
                  onClose={handleViajesClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{ ml: 1 }}
                >
                  <MenuItem onClick={() => handleNavigation("/viajes")}>
                    Tabla
                  </MenuItem>
                  <MenuItem onClick={() => handleNavigation("/calendario")}>
                    Calendario Semanal
                  </MenuItem>
                  <MenuItem onClick={() => handleNavigation("/calendario/mensual")}>
                    Calendario Mensual
                  </MenuItem>
                </Menu>
              </div>
            )}

            {/* ✅ DOCUMENTOS CON MENU DE MUI */}
            {(hasPermission("viajes.leer")) && (
              <div className="submenu">
                <button
                  onClick={handleDocumentosClick}
                  className={`navButton${isActiveParent("/certificados", "/GastosReales") ? " active" : ""}`}
                  title={!isOpen ? "Documentos" : ""}
                  style={{ width: "100%", justifyContent: "flex-start" }}
                >
                  <div className="buttonDiv">
                    <DocumentI className="icon" />
                    {isOpen && (
                      <label className="label">Generacion Docs.</label>
                    )}
                    {isOpen &&
                      (expandedSections.documentos ? (
                        <ExpandLessI />
                      ) : (
                        <ExpandMoreI />
                      ))}
                  </div>
                </button>

                {/* Submenú normal cuando está abierto */}
                {isOpen && expandedSections.documentos && (
                  <div className="submenuContent">
                    <button
                      onClick={() => handleNavigation("/certificados")}
                      className={`navButton submenuButton${isActive("/certificados") ? " active" : ""}`}
                    >
                      <span>Certificado de Limpieza</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/GastosReales")}
                      className={`navButton submenuButton${isActive("/GastosReales") ? " active" : ""}`}
                    >
                      <span>Gastos Reales</span>
                    </button>
                  </div>
                )}

                {/* Menu de MUI cuando está cerrado */}
                <Menu
                  anchorEl={documentosAnchor}
                  open={documentosMenuOpen}
                  onClose={handleDocumentosClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{ ml: 1 }}
                >
                  <MenuItem onClick={() => handleNavigation("/certificados")}>
                    Certificado de Limpieza
                  </MenuItem>
                  <MenuItem onClick={() => handleNavigation("/GastosReales")}>
                    Gastos Reales
                  </MenuItem>
                </Menu>
              </div>
            )}

            {/* ✅ BITACORAS CON SUBMENU */}
            {(hasPermission("bitacoras.leer")) && (
              <div className="submenu">
                <button
                  onClick={handleBitacorasClick}
                  className={`navButton${isActiveParent("/bitacoras", "/registroBitacoras") ? " active" : ""}`}
                  title={!isOpen ? "Bitácoras" : ""}
                  style={{ width: "100%", justifyContent: "flex-start" }}
                >
                  <div className="buttonDiv">
                    <BitacoraI className="icon" />
                    {isOpen && <label className="label">Bitácoras</label>}
                    {isOpen &&
                      (expandedSections.bitacoras ? (
                        <ExpandLessI />
                      ) : (
                        <ExpandMoreI />
                      ))}
                  </div>
                </button>

                {/* Submenú cuando está abierto */}
                {isOpen && expandedSections.bitacoras && (
                  <div className="submenuContent">
                    <button
                      onClick={() => handleNavigation("/bitacoras")}
                      className={`navButton submenuButton${isActive("/bitacoras") ? " active" : ""}`}
                    >
                      <span>Lista</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/registroBitacoras")}
                      className={`navButton submenuButton${isActive("/registroBitacoras") ? " active" : ""}`}
                    >
                      <span>Modificar Bitacora</span>
                    </button>
                  </div>
                )}

                {/* Menu de MUI cuando está cerrado */}
                <Menu
                  anchorEl={bitacorasAnchor}
                  open={bitacorasMenuOpen}
                  onClose={handleBitacorasClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{ ml: 1 }}
                >
                  <MenuItem onClick={() => handleNavigation("/bitacoras")}>
                    Lista
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleNavigation("/registroBitacoras")}
                  >
                    Modificar Bitacora
                  </MenuItem>
                </Menu>
              </div>
            )}

            {(hasPermission("choferes.leer")) && (
              <button
                onClick={() => handleNavigation("/choferes")}
                title={!isOpen ? "Choferes" : ""}
                className={`navButton${isActive("/choferes") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <ChoferesI className="icon" />
                  {isOpen && <label className="label">Operadores</label>}
                </div>
              </button>
            )}

            {(hasPermission("unidades.leer")) && (
              <button
                onClick={() => handleNavigation("/unidades")}
                title={!isOpen ? "Unidades" : ""}
                className={`navButton${isActive("/unidades") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <UnidadesI className="icon" />
                  {isOpen && <label className="label">Unidades</label>}
                </div>
              </button>
            )}

            {(hasPermission("viajes.leer")) && (
              <button
                onClick={() => handleNavigation("/materiales")}
                title={!isOpen ? "Materiales" : ""}
                className={`navButton${isActive("/materiales") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <MaterialesI className="icon" />
                  {isOpen && <label className="label">Materiales</label>}
                </div>
              </button>
            )}

            {(hasPermission("clientes.leer")) && (
              <button
                onClick={() => handleNavigation("/clientes")}
                title={!isOpen ? "Clientes" : ""}
                className={`navButton${isActive("/clientes") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <ClientesI className="icon" />
                  {isOpen && <label className="label">Clientes</label>}
                </div>
              </button>
            )}
            {(hasPermission("vacaciones.leer")) && (
              <button
                onClick={() => handleNavigation("/vacaciones")}
                title={!isOpen ? "Vacaciones" : ""}
                className={`navButton${isActive("/vacaciones") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <VacacionesI className="icon" />
                  {isOpen && <label className="label">Vacaciones</label>}
                </div>
              </button>
            )}
            {(hasPermission("choferes.leer")) && (
              <button
                onClick={() => handleNavigation("/empleados")}
                title={!isOpen ? "Empleados" : ""}
                className={`navButton${isActive("/empleados") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <BadgeIcon className="icon" />
                  {isOpen && <label className="label">Empleados</label>}
                </div>
              </button>
            )}

            {/* ✅ RUTAS CON SUBMENU */}
            {(hasPermission("rutas.leer")) && (
              <div className="submenu">
                <button
                  onClick={handleRutasClick}
                  className={`navButton${isActiveParent("/rutas", "/casetas", "/puntosRuta") ? " active" : ""}`}
                  title={!isOpen ? "Rutas" : ""}
                  style={{ width: "100%", justifyContent: "flex-start" }}
                >
                  <div className="buttonDiv">
                    <RutasI className="icon" />
                    {isOpen && <label className="label">Rutas</label>}
                    {isOpen &&
                      (expandedSections.rutas ? (
                        <ExpandLessI />
                      ) : (
                        <ExpandMoreI />
                      ))}
                  </div>
                </button>

                {/* Submenú cuando está abierto */}
                {isOpen && expandedSections.rutas && (
                  <div className="submenuContent">
                    <button
                      onClick={() => handleNavigation("/rutas")}
                      className={`navButton submenuButton${isActive("/rutas") ? " active" : ""}`}
                    >
                      <span>Lista de Rutas</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/casetas")}
                      className={`navButton submenuButton${isActive("/casetas") ? " active" : ""}`}
                    >
                      <span>Casetas</span>
                    </button>
                    <button
                      onClick={() => handleNavigation("/puntosRuta")}
                      className={`navButton submenuButton${isActive("/puntosRuta") ? " active" : ""}`}
                    >
                      <span>Puntos de Rutas</span>
                    </button>
                  </div>
                )}

                {/* Menu de MUI cuando está cerrado */}
                <Menu
                  anchorEl={rutasAnchor}
                  open={rutasMenuOpen}
                  onClose={handleRutasClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{ ml: 1 }}
                >
                  <MenuItem onClick={() => handleNavigation("/rutas")}>
                    Lista de Rutas
                  </MenuItem>
                  <MenuItem onClick={() => handleNavigation("/casetas")}>
                    Casetas
                  </MenuItem>
                  <MenuItem onClick={() => handleNavigation("/puntosRuta")}>
                    Puntos de Rutas
                  </MenuItem>
                </Menu>
              </div>
            )}
            {(hasPermission("viajes.leer")) && (
              <button
                onClick={() => handleNavigation("/analiticas")}
                title={!isOpen ? "Puntos de Rutas" : ""}
                className={`navButton${isActive("/analiticas") ? " active" : ""}`}
              >
                <div className="buttonDiv">
                  <PuntosI className="icon" />
                  {isOpen && <label className="label">Analiticas</label>}
                </div>
              </button>
            )}
          </div>
        </div>

        {/* ✅ SECCIÓN ADMINISTRATIVA */}
        {(hasPermission("usuarios.leer") ||
          hasPermission("configuracion.ver")) && (
          <div className="navSection">
            {isOpen && (
              <button
                className="sectionHeader"
                onClick={() => toggleSection("admin")}
              >
                <span>Administración</span>
                {expandedSections.admin ? <ExpandLessI /> : <ExpandMoreI />}
              </button>
            )}

            <div
              className={`sectionContent ${
                isOpen
                  ? expandedSections.admin
                    ? "visible"
                    : "hidden"
                  : "iconsOnly"
              }`}
            >
              {(hasPermission("usuarios.leer")) && (
                <button
                  onClick={() => handleNavigation("/usuarios")}
                  title={!isOpen ? "Usuarios" : ""}
                  className={`navButton${isActive("/usuarios") ? " active" : ""}`}
                >
                  <div className="buttonDiv">
                    <UsuariosI className="icon" />
                    {isOpen && <label className="label">Usuarios</label>}
                  </div>
                </button>
              )}

              {(hasPermission("configuracion.editar")) && (
                <button
                  onClick={() => handleNavigation("/roles")}
                  title={!isOpen ? "Roles" : ""}
                  className={`navButton${isActive("/roles") ? " active" : ""}`}
                >
                  <div className="buttonDiv">
                    <RolesI className="icon" />
                    {isOpen && <label className="label">Roles</label>}
                  </div>
                </button>
              )}

              {(hasPermission("configuracion.ver")) && (
                <button
                  onClick={() => handleNavigation("/permisos")}
                  title={!isOpen ? "Permisos" : ""}
                  className={`navButton${isActive("/permisos") ? " active" : ""}`}
                >
                  <div className="buttonDiv">
                    <PermisosI className="icon" />
                    {isOpen && <label className="label">Permisos</label>}
                  </div>
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {/* ✅ CONTROLES DEL NAVBAR */}
      <div className="navControls">
        <button
          onClick={toggleNavbar}
          className="controlButton"
          title={!isOpen ? "Expandir sidebar" : "Contraer sidebar"}
          aria-label={isOpen ? "Contraer sidebar" : "Expandir sidebar"}
        >
          <div className="buttonDiv">
            {isOpen ? (
              <CloseFullscreenIcon className="icon" />
            ) : (
              <OpenInFullIcon className="icon" />
            )}
            {isOpen && (
              <label className="label">
                {isOpen ? "Contraer" : "Expandir"}
              </label>
            )}
          </div>
        </button>

        <button
          onClick={toggleMode}
          className="controlButton"
          title={!isOpen ? (mode === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro") : ""}
          aria-label={mode === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
        >
          <div className="buttonDiv">
            {mode === "dark" ? (
              <LightModeIcon className="icon" />
            ) : (
              <DarkModeIcon className="icon" />
            )}
            {isOpen && (
              <label className="label">
                {mode === "dark" ? "Modo claro" : "Modo oscuro"}
              </label>
            )}
          </div>
        </button>

        <button
          onClick={handleLogout}
          className="logoutButton"
          title={!isOpen ? "Cerrar sesión" : ""}
          aria-label="Cerrar sesión"
        >
          <div className="buttonDiv">
            <LogoutI className="icon" />
            {isOpen && <label className="label">Cerrar Sesión</label>}
          </div>
        </button>
      </div>
    </div>
  );
}

export default Navbar;
